export type Route =
  | '/'
  | '/company'
  | '/service'
  | '/news/all/1'
  | '/recruitment'
  | '/contact'
  | '/projects'
  | '/simulation'
  | '/privacyPolicy'
  | '/szwb'

interface Routes {
  readonly text: string
  readonly route: Route
}

/**
 * パスの一覧
 */
export const ALL_ROUTE: Routes[] = [
  // ホーム
  { text: 'Home', route: '/' },
  // 会社情報
  { text: 'Company', route: '/company' },
  // サービス
  { text: 'Service', route: '/service' },
  // サスティナビリティ
  // { text: "sustainability", route: "/sustainability" },
  // ニュース
  { text: 'News', route: '/news/all/1' },
  // ブログ
  // { text: "", route: "/blog" },
  // 採用
  { text: 'Recruitment', route: '/recruitment' },
  // 給料シュミレーション
  { text: 'Salary Simulation', route: '/simulation' },
  // お問い合わせ
  { text: 'Contact', route: '/contact' },
  // プライバシーポリシー
  { text: 'Privacy Policy', route: '/privacyPolicy' },
  // 案件
  { text: 'Projects', route: '/projects' },
  // SOZO White Box
] as const

// SOZO White Box
export const SOZO_WHITE_BOX_ROUTES = {
  text: 'White Box',
  link: 'https://quaint-meerkat-59f.notion.site/SOZO-White-Box-ce7e4308f9aa41349fdac8c9e1e8e6ae',
}

// Portfolio
export const PORTFOLIO_ROUTES = {
  text: 'Portfolio',
  link: 'https://quaint-meerkat-59f.notion.site/Group-Company-Portfolio-3f01d1359c9e44bab26f34428ef8f145',
}

// Community
export const COMMUNITY_ROUTES = {
  text: 'Community',
  link: 'https://alchemy.connpass.com/',
}

// ヘッダー用
export const HEADER_ROUTES: Routes[] = ALL_ROUTE.filter(
  (route) =>
    route.route === '/service' ||
    route.route === '/company' ||
    route.route === '/news/all/1' ||
    route.route === '/simulation' ||
    route.route === '/contact',
)

// フッター用
export const FOOTER_ROUTES: Routes[] = ALL_ROUTE.filter(
  (route) =>
    route.route === '/company' ||
    route.route === '/service' ||
    route.route === '/news/all/1' ||
    route.route === '/simulation' ||
    route.route === '/privacyPolicy',
)
export const SITE_URL = 'https://sozo-inc.jp' as const

export const ENTRY_LINK =
  'https://www.wantedly.com/companies/sozo1029/projects' as const

export const CONPANY_NAME = 'SOZO inc.' as const

export const MVV = {
  philosophy: {
    title: '関わるすべての人を幸せに',
    subTitle: 'Happiness for all involved',
    description:
      '仕事は、人生を豊かにするための一つの手段と考えています。社会貢献や自己成長も重要ですが、まずは仕事やプライベートを通して身近な人々を幸せにしていくことが、真の成功へと繋がっていくと信じています。SOZOは、そうした価値観を持つ人材を育成し、世の中に送り出すことを目指して活動を続けます。',
  },
  misson: {
    head: '“Our Mission”',
    title: '挑戦するなら、SOZO',
    description:
      'SOZOの使命は、挑戦するすべての人々に活躍の場を提供し続けることです。分野を問わず好きなことに夢中となり、その結果として世の中に影響を与える人材を育成します。挑戦を恐れず、夢中で取り組むことで生まれる力が、新たな価値を創造することを信じています。',
  },
  vision: {
    head: '“Our Vision”',
    title: '「やりたい」を見つけ、\n叶えられる場所を提供します',
    description:
      'SOZOは、自分の「やりたい」を見つけることができ、それを実現できる環境を提供します。好奇心と情熱を持って挑戦することが、自身の可能性を最大限に発揮できる場を創り出し、メンバーが目指す未来を共に築きます。',
  },
  value: {
    head: '“Our Value”',
    title: '私たちのValue',
    description: '私たちは、これらのValueを体現し、挑戦の場を提供します。',
    company: [
      {
        title: 'メンバーの「やりたい」を把握',
        description:
          'メンバー一人ひとりの「やりたい」を探求、尊重し、最大限にサポートすることを重視しています。そのために、会社として徹底的なヒアリングを実施し、個々の情熱や目標を把握します。対話を通じて、メンバーが自身の力を発揮できる最適な環境を提供し、共に成長していくことを目指します。',
      },
      {
        title: 'コラボレーションの尊重',
        description:
          'コラボレーションを企業の基盤として重視しています。協力とチームワークを通じて、異なる専門性を持つメンバーが互いに補完し合い、相乗効果を生み出すことを目指します。',
      },
      {
        title: '心理的安全性',
        description:
          '全てのメンバーが自由に意見を共有できる心理的安全性の高い環境づくりを目指します。安心して発言できる場を提供することにより、メンバー同士が積極的にコミュニケーションを行い、新しいアイデアや意見を出し合うことが可能となります。多様な意見やバックグラウンドを尊重し、失敗や批判を恐れずに話し合える文化を築くことで、メンバー全員が共に成長し、協力し合う組織を実現します。',
      },
    ],
    members: [
      {
        title: '技術探求',
        description:
          '技術やトレンドを常に追い求める姿勢を大切にしています。技術の進化に敏感に反応し、変化を先取りすることで、よりよい価値を提供していくことを目指します。',
      },
      {
        title: '挑戦することを恐れない',
        description:
          '失敗を成長のための一歩と捉えています。挑戦する過程で生じる失敗は、新たな学びと経験をもたらし、成功へのステップになります。メンバーには、失敗を恐れるのではなく、恐れずに挑戦し続ける姿勢を持っていただきたいと考えています。',
      },
      {
        title: '問題解決能力',
        description:
          '問題解決能力の向上は、成長するためには非常に重要だと考えています。メンバー自身が、問題に対して戦略的にアプローチし、物事の本質を捉えた思考を養うことができる状態を目指します。',
      },
    ],
  },
} as const

export const SERVICE = [
  {
    title: 'システムエンジニアリング事業',
    description:
      'お客様先にリモート / 出社で常駐し、開発/保守/運用の技術支援を手掛け、EC系サービス、マーケティング、人材系、B2B、B2C、飲食、美容、医療、金融など幅広い業界でWeb開発を行っています。',
  },
  {
    title: 'IT・Web領域における教育',
    description:
      '独自のカリキュラムに基づくIT・Web領域開発者育成を社内研修並びに企業様向けに行っています。',
  },
  {
    title: 'Webコンテンツの企画・制作事業',
    description:
      'クライアント企業様のホームページやランディングページの制作・運用、ECサイトの構築を行っています。',
  },
] as const

/** 各在籍年数の還元率 */
export const BASE_RATES = [
  0.52, // 1年目のmax
  0.56, // 2年目のmax
  0.6, // 3年目のmax
  0.64, // 4年目のmax
  0.68, // 5年目のmax
  0.72, // 6年目のmax
  0.76, // 7年目のmax
  0.8, // 8年目のmax
  0.84, // 9年目のmax
  0.88, // 10年目のmax
] as const

/**
 * リーダー案件の還元率
 */
export const LEADER_RATES = [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.06] as const

/** ニュース詳細の1ページにおける最大記事数*/
export const PER_PAGE = 10 as const
